var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.myMode == "login"
        ? _c("ClientLogin", {
            attrs: { modal: _vm.modal },
            on: {
              signup: function ($event) {
                _vm.myMode = "signup"
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.myMode == "signup"
        ? _c("ClientSignup", {
            attrs: { modal: _vm.modal },
            on: {
              login: function ($event) {
                _vm.myMode = "login"
              },
              askComoCode: _vm.askComoCode,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.myMode == "comoCode"
        ? _c("ComoLoginCode", {
            attrs: { modal: _vm.modal, client: _vm.client },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }